import React, { useState } from 'react';

function ModelSelector({ onGenerate }) {
  const [selectedModel, setSelectedModel] = useState('random');
  const [count, setCount] = useState(1);
  const [excludeNumbers, setExcludeNumbers] = useState('');
  const [fixedNumbers, setFixedNumbers] = useState('');
  const [loading, setLoading] = useState(false);

  const models = [
    { id: 'random', name: '완전 랜덤', description: '1-45 무작위 선택' },
    { id: 'high-freq', name: '고빈도 번호', description: '자주 나온 번호 우선' },
    { id: 'low-freq', name: '저빈도 번호', description: '오랫동안 안 나온 번호' },
    { id: 'pattern', name: '패턴 기반', description: '통계적 패턴 적용' },
    { id: 'exclude', name: '제외 번호', description: '특정 번호 제외' },
    { id: 'fixed', name: '고정 번호', description: '특정 번호 포함' },
    { id: 'hybrid', name: '혼합 전략', description: '여러 전략 조합' }
  ];

  const handleGenerate = async () => {
    setLoading(true);

    try {
      const options = { count };

      // Parse exclude numbers
      if (selectedModel === 'exclude' && excludeNumbers.trim()) {
        const numbers = excludeNumbers.split(',').map(n => parseInt(n.trim())).filter(n => !isNaN(n) && n >= 1 && n <= 45);
        if (numbers.length === 0) {
          alert('1~45 사이의 번호를 입력해주세요 (예: 1,2,3)');
          setLoading(false);
          return;
        }
        options.excludeNumbers = numbers;
      }

      // Parse fixed numbers
      if (selectedModel === 'fixed' && fixedNumbers.trim()) {
        const numbers = fixedNumbers.split(',').map(n => parseInt(n.trim())).filter(n => !isNaN(n) && n >= 1 && n <= 45);
        if (numbers.length === 0) {
          alert('1~45 사이의 번호를 입력해주세요 (예: 7,13)');
          setLoading(false);
          return;
        }
        options.fixedNumbers = numbers;
      }

      await onGenerate(selectedModel, options);
    } catch (error) {
      alert('번호 생성 중 오류가 발생했습니다: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="model-selector">
      <h2>번호 생성 방식 선택</h2>

      <div className="model-grid">
        {models.map(model => (
          <button
            key={model.id}
            className={`model-button ${selectedModel === model.id ? 'active' : ''}`}
            onClick={() => setSelectedModel(model.id)}
            disabled={loading}
          >
            <div className="model-name">{model.name}</div>
            <div className="model-desc">{model.description}</div>
          </button>
        ))}
      </div>

      {selectedModel === 'exclude' && (
        <div className="model-options">
          <label>제외할 번호 (쉼표로 구분):</label>
          <input
            type="text"
            placeholder="예: 1,2,3,4,5"
            value={excludeNumbers}
            onChange={(e) => setExcludeNumbers(e.target.value)}
            disabled={loading}
          />
        </div>
      )}

      {selectedModel === 'fixed' && (
        <div className="model-options">
          <label>고정할 번호 (쉼표로 구분):</label>
          <input
            type="text"
            placeholder="예: 7,13,21"
            value={fixedNumbers}
            onChange={(e) => setFixedNumbers(e.target.value)}
            disabled={loading}
          />
        </div>
      )}

      <div className="count-selector">
        <label>생성할 세트 수:</label>
        <div className="count-buttons">
          {[1, 3, 5].map(num => (
            <button
              key={num}
              className={`count-button ${count === num ? 'active' : ''}`}
              onClick={() => setCount(num)}
              disabled={loading}
            >
              {num}개
            </button>
          ))}
        </div>
      </div>

      <button
        className="generate-button"
        onClick={handleGenerate}
        disabled={loading}
      >
        {loading ? '생성 중...' : '번호 생성하기'}
      </button>
    </div>
  );
}

export default ModelSelector;
